// extracted by mini-css-extract-plugin
module.exports = {"headerActions":"SupplierPurchasePendingPage_headerActions__fBXaI"};